import axios from 'axios';
import router from '@/router/index';
import store from '@/store';

// axios 响应拦截器
axios.interceptors.response.use((data) => {
    if (data.status === 204) {
        data.data = {}; // todo
    }
    return data.data;
}, (err) => {
    const { status } = err.response;
    switch (status) {
        case 403: return err.response.data;
        case 400: return err.response.data;
        case 401: store.commit('loginVisible', true); return { error: { message: '' }, status: 401 };
        case 500: router.push({ path: '/error' }); return { status: 500, error: { message: '' } };
        case 404: return err.response.data;
        default: return { error: { message: '' }, status };
    }
});
